<template>
  <v-menu
    v-model="isOpen"
    :close-on-content-click="false"
    location="bottom start"
  >
    <template #activator="{ props: menuProps }">
      <input
        :value="modelValue"
        v-bind="menuProps"
        class="datetime-input"
        type="text"
        :placeholder="placeholder"
        readonly
      >
    </template>
    <VueDatePicker
      :model-value="modelValue"
      locale="ja"
      format="yyyy/MM/dd HH:mm"
      model-type="yyyy/MM/dd HH:mm"
      :enable-time-picker="true"
      :clearable="true"
      inline
      @update:model-value="handleUpdate"
    />
  </v-menu>
</template>

<script>
export default {
  name: "DateTimeField",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "YYYY/MM/DD HH:mm"
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    handleUpdate(value) {
      this.$emit("update:modelValue", value ?? "");
      this.isOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.datetime-input {
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  color: rgba(0, 0, 0, 0.72);
  cursor: pointer;
  font-size: 12px;
  height: 30px;
  line-height: 1.5;
  padding: 6px 8px;
  width: 100%;
}
</style>
